import ReactDOM from "react-dom";
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

function PersonalMinimums({ onClose }) {
    const { refreshUser } = useAuth();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");

    const [displayName, setDisplayName] = useState("");
    const [fullName, setFullName] = useState("");

    const [ifrCeiling, setIfrCeiling] = useState(500);

    const [ifrVisibility, setIfrVisibility] = useState(1.0);

    const [crosswindMax, setCrosswindMax] = useState(20);

    const [tailwindMax, setTailwindMax] = useState(10);

    const [alternateCeiling, setAlternateCeiling] = useState(2000);

    const [alternateVisibility, setAlternateVisibility] = useState(5.0);

    const [preferredRunwayLength, setPreferredRunwayLength] = useState(5000);

    const [homeAirport, setHomeAirport] = useState("");
    const [defaultAircraft, setDefaultAircraft] = useState("");

    useEffect(() => {
        loadProfile();
    }, []);

    async function loadProfile() {
        try {
            const token = localStorage.getItem("token");

            const response = await fetch("https://ficon-x.com/auth/me", {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Unable to load profile");
            }

            setUsername(data.username || "");
            setEmail(data.email || "");
            setDisplayName(data.display_name || "");
            setFullName(data.full_name || "");
            setHomeAirport(data.home_airport || "");
            setDefaultAircraft(data.default_aircraft || "");
            setIfrCeiling(data.ifr_ceiling_min_ft ?? 500);

            setIfrVisibility(data.ifr_visibility_min_sm ?? 1.0);

            setCrosswindMax(data.crosswind_max_kt ?? 20);

            setTailwindMax(data.tailwind_max_kt ?? 10);

            setAlternateCeiling(data.alternate_ceiling_min_ft ?? 2000);

            setAlternateVisibility(data.alternate_visibility_min_sm ?? 5.0);

            setPreferredRunwayLength(data.preferred_runway_length_ft ?? 5000);
        } catch (err) {
            console.error(err);
            alert("Failed to load profile.");
        } finally {
            setLoading(false);
        }
    }

    async function saveProfile() {
        try {
            setSaving(true);

            const token = localStorage.getItem("token");

            const response = await fetch(
                "https://ficon-x.com/auth/update-profile",
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        display_name: displayName,
                        full_name: fullName,
                        home_airport: homeAirport,
                        default_aircraft: defaultAircraft,
                        ifr_ceiling_min_ft: ifrCeiling,

                        ifr_visibility_min_sm: ifrVisibility,

                        crosswind_max_kt: crosswindMax,

                        tailwind_max_kt: tailwindMax,

                        alternate_ceiling_min_ft: alternateCeiling,

                        alternate_visibility_min_sm: alternateVisibility,

                        preferred_runway_length_ft: preferredRunwayLength,
                    })
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data.error ||
                    "Save failed"
                );
            }

            // =====================================
            // 🔄 REFRESH AUTH USER
            // Makes new personal minimums available
            // immediately throughout FICON-X
            // =====================================

            await refreshUser();

            console.log(
                "✅ Personal minimums saved and active"
            );

            alert(
                "Personal minimums updated successfully."
            );

            if (onClose) {
                onClose();
            }
        } catch (err) {
            console.error(err);
            alert("Unable to save profile.");
        } finally {
            setSaving(false);
        }
    }

    if (loading) {
        return (
            <div style={{ padding: "20px" }}>
                Loading Profile...
            </div>
        );
    }

return ReactDOM.createPortal(

<div
    style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.45)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999999
    }}
>

    <div
        style={{
            width: "500px",
            maxWidth: "95%",
            margin: "30px auto",
            background: "#ffffff",
            borderRadius: "10px",
            padding: "25px",
            boxShadow: "0 10px 40px rgba(0,0,0,.35)"
        }}
    >
        <hr />

        <h3 style={{ marginTop: "20px", marginBottom: "15px" }}>
            Personal Minimums
        </h3>

        {/* IFR Ceiling */}
        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                IFR Ceiling Minimum
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Lowest ceiling you're comfortable flying.
            </div>

            <input
                type="number"
                value={ifrCeiling}
                onChange={(e) => setIfrCeiling(Number(e.target.value))}
                style={{
                    width: "120px",
                    padding: "8px"
                }}
            /> ft AGL
        </div>

        {/* IFR Visibility */}
        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                IFR Visibility Minimum
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Minimum flight visibility.
            </div>

            <input
                type="number"
                step="0.5"
                value={ifrVisibility}
                onChange={(e) => setIfrVisibility(Number(e.target.value))}
                style={{
                    width: "120px",
                    padding: "8px"
                }}
            /> SM
        </div>

        {/* Crosswind */}
        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                Maximum Crosswind
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Maximum acceptable crosswind component.
            </div>

            <input
                type="number"
                value={crosswindMax}
                onChange={(e) => setCrosswindMax(Number(e.target.value))}
                style={{
                    width: "120px",
                    padding: "8px"
                }}
            /> kt
        </div>

        {/* Tailwind */}
        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                Maximum Tailwind
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Maximum acceptable tailwind component.
            </div>

            <input
                type="number"
                value={tailwindMax}
                onChange={(e) => setTailwindMax(Number(e.target.value))}
                style={{
                    width: "120px",
                    padding: "8px"
                }}
            /> kt
        </div>

        <hr style={{ margin: "25px 0" }} />

        <h3 style={{ marginBottom: "15px" }}>
            Alternate Preferences
        </h3>

        {/* Alternate Ceiling */}
        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                Alternate Ceiling Minimum
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Minimum ceiling for suggested alternates.
            </div>

            <input
                type="number"
                value={alternateCeiling}
                onChange={(e) => setAlternateCeiling(Number(e.target.value))}
                style={{
                    width: "120px",
                    padding: "8px"
                }}
            /> ft AGL
        </div>

        {/* Alternate Visibility */}
        <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "600" }}>
                Alternate Visibility Minimum
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Minimum visibility for suggested alternates.
            </div>

            <input
                type="number"
                step="0.5"
                value={alternateVisibility}
                onChange={(e) => setAlternateVisibility(Number(e.target.value))}
                style={{
                    width: "120px",
                    padding: "8px"
                }}
            /> SM
        </div>

        {/* Runway Length */}
        <div style={{ marginBottom: "20px" }}>
            <label style={{ fontWeight: "600" }}>
                Preferred Runway Length
            </label>

            <div
                style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "2px",
                    marginBottom: "5px"
                }}
            >
                Minimum runway length for suggested alternates.
            </div>

            <input
                type="number"
                value={preferredRunwayLength}
                onChange={(e) => setPreferredRunwayLength(Number(e.target.value))}
                style={{
                    width: "120px",
                    padding: "8px"
                }}
            /> ft
        </div>

        <div
    style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        marginTop: "25px"
    }}
>
    <button
        onClick={() => {
            if (onClose) {
                onClose();
            }
        }}
    >
        Cancel
    </button>

    <button
        onClick={saveProfile}
        disabled={saving}
    >
        {saving ? "Saving..." : "Save Minimums"}
    </button>
</div>
        </div>

    </div>,

    document.body

);
}

export default PersonalMinimums;